// Function to initialize a single carousel
function initCarousel(carousel) {
  if (carousel.classList.contains('jm-carousel-initialized')) {
    return;
  }
  carousel.classList.add('jm-carousel-initialized');

  var track = carousel.querySelector('.jm-carousel__track');
  if (!track) {
    return;
  }

  var slides = Array.from(track.children);
  
  // Check slides length BEFORE removing them
  if (!slides.length) {
    return;
  }

  // Remove slides from track
  slides.forEach(slide => slide.remove());

  var wrapper = document.createElement('div');
  wrapper.className = 'swiper-wrapper';
  
  slides.forEach(function (slide) {
    var swiperSlide = document.createElement('div');
    swiperSlide.className = 'swiper-slide';
    swiperSlide.appendChild(slide);
    wrapper.appendChild(swiperSlide);
  });

  var swiper = document.createElement('div');
  swiper.className = 'swiper jm-carousel-swiper';
  swiper.appendChild(wrapper);

  var navigationDiv = document.createElement('div');
  navigationDiv.className = 'ds-swiper-navigation-container';

  var prevBtn = document.createElement('div');
  prevBtn.className = 'swiper-button-prev';
  
  var nextBtn = document.createElement('div');
  nextBtn.className = 'swiper-button-next';

  navigationDiv.append(prevBtn, nextBtn);
  swiper.append(navigationDiv);
  track.replaceWith(swiper);

  var styles = window.getComputedStyle(carousel);
  var gap = parseInt(styles.getPropertyValue('--carousel-gap') || '50', 10);
  var perView = parseInt('3', 10);

  // eslint-disable-next-line no-new
  new window.Swiper(swiper, {
    slidesPerView: perView,
    spaceBetween: gap,
    grabCursor: true,
    breakpoints: {
      0: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 3
      }
    },
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn
    }
  });
}

function addHeadingIcon() {
  var heading = document.querySelector('.jm-review-widget-minimal-header__title');

  if (heading && !heading.querySelector('.heading-lightning-bolt-icon')) {
    var newElement = document.createElement('span');
    newElement.className = 'heading-lightning-bolt-icon';
    heading.appendChild(newElement);
  }
}

// Initialize all existing carousels
function initAllCarousels() {
  document.querySelectorAll('.jm-carousel').forEach(initCarousel);
}

// Initialize heading icon if element exists
function initHeadingIcon() {
  var heading = document.querySelector('.jm-review-widget-minimal-header__title');
  if (heading) {
    addHeadingIcon();
  }
}

// Watch for new carousels and heading elements being added to the DOM
var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      // Check if the added node is an element
      if (node.nodeType === 1) {
        // Check if the node itself is a carousel
        if (node.classList && node.classList.contains('jm-carousel')) {
          initCarousel(node);
        }
        // Check if the node contains carousels
        if (node.querySelectorAll) {
          node.querySelectorAll('.jm-carousel').forEach(initCarousel);
          
          // Check if the heading element is present
          if (node.querySelector('.jm-review-widget-minimal-header__title')) {
            addHeadingIcon();
          }
        }
        // Check if the node itself is the heading
        if (node.classList && node.classList.contains('jm-review-widget-minimal-header__title')) {
          addHeadingIcon();
        }
      }
    });
  });
});

// Start observing
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Initialize on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initAllCarousels();
    initHeadingIcon();
  });
} else {
  initAllCarousels();
  initHeadingIcon();
}